import { CORE_PAGES } from '@core-ui/components';

export const PagesWithoutSettingsSidebar: Record<string, boolean> = {
    [CORE_PAGES.SETTINGS.CONFIRM_PAYMENT]: true,
    [CORE_PAGES.SETTINGS.COMPLETE_PAYMENT]: true,
    [CORE_PAGES.SETTINGS.CONFIRM_PLAN]: true,
    [CORE_PAGES.SETTINGS.SELECT_PLAN]: true,
    [CORE_PAGES.SETTINGS.CURRENT_PLAN]: true,
    [CORE_PAGES.SETTINGS.CHANGE_SUBSCRIPTION]: true,
    [CORE_PAGES.SETTINGS.CHANGE_SUBSCRIPTION_CHECKOUT]: true,
    [CORE_PAGES.SETTINGS.CANCEL_PLAN]: true,
};
